import React from "react";

// Sprint RIFINITURE — nome del venditore come lo restituisce il server (disattivati compresi).
// Il segno «non attivo» vale solo a video: le stampe riportano il nome e basta.
export function NomeVenditore({ vendita, testid = "nome-venditore" }) {
  const nome = vendita?.venditore_nome;
  if (!vendita?.venditore_id) return <span className="text-slate-400" data-testid={testid}>—</span>;
  if (vendita.venditore_stato === "non_disponibile") {
    return <span className="italic text-slate-400" data-testid={testid}>{nome}</span>;
  }
  return (
    <span className="inline-flex items-center gap-1" data-testid={testid}>
      <span>{nome}</span>
      {vendita.venditore_stato === "disattivato" && (
        <span className="text-[10px] text-slate-400 border border-slate-200 rounded px-1 leading-4"
              title="Utente non più attivo" data-testid={`${testid}-non-attivo`}>non attivo</span>
      )}
    </span>
  );
}
